import { ParsedUrlQuery } from 'querystring';

import { useEffect, useMemo, useState } from 'react';

import { useQuery } from '@tanstack/react-query';
import { useParams, useSearchParams } from 'next/navigation';

import { SearchViewModel } from '@api/v3';
import { callService } from '@api/remote-call';
import { useSearchURL } from '@api/data-loaders/resource';
import { paramsToObject } from '@components/views/utils';

export const useSelectedLocationSearch = (
  enabled: boolean,
  queryDependency: any[] = []
) => {
  const searchParams = useSearchParams();
  const query: ParsedUrlQuery = useMemo(() => {
    return paramsToObject(searchParams?.entries());
  }, [searchParams]);
  const params = useParams();
  const urlData = useSearchURL();

  const [selectedLocation, setSelectedLocation] =
    useState<SearchViewModel>(urlData);
  // ================================================
  // Fetch locations/hotels and fill the search by location
  // ================================================
  const fetchLocationsItems = async () => {
    return callService(
      { service: 'SearchesService', method: 'searchesUrl', version: 'v3' },
      {
        s: String(params?.slug),
      }
    );
  };

  const { data: searchLocation } = useQuery(
    ['selectedLocation', JSON.stringify(query), ...queryDependency],
    fetchLocationsItems,
    { enabled, initialData: urlData }
  );

  useEffect(() => {
    if (!searchLocation) return;

    setSelectedLocation(searchLocation);
  }, [searchLocation, query]);

  return { selectedLocation };
};
